import Vue from 'vue'
import store from '../../vuex'
import * as restfulService from './restfulService'

function _checkHeimdallToken () {
  return new Promise((resolve) => {
    let token = Vue.cookie.get('heimdall_token')
    if (token) {
      let data = {token}
      resolve(_login(data))
    } else {
      resolve()
    }
  })
}

function _login (data) {
  return new Promise((resolve, reject) => {
    restfulService.post('auth', 'login', null, data)
      .then(loginResponse => {
        if (loginResponse.heimdall_token) {
          Vue.cookie.set('heimdall_token', loginResponse.heimdall_token, {domain: process.env.DOMAIN})
        }
        let person = loginResponse.user.pessoa
        loginResponse.user = {
          id: loginResponse.user.id,
          ref_pessoa: loginResponse.user.ref_pessoa,
          name: person.nome
        }
        store.dispatch('login', loginResponse).then(response => {
          resolve(response)
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

function _logout () {
  return new Promise((resolve, reject) => {
    let token = Vue.cookie.get('heimdall_token')
    let data = {}
    if (token) {
      data.token = token
    }
    restfulService.post('auth', 'logout', null, data)
      .then(() => {
        Vue.cookie.delete('heimdall_token', {domain: process.env.DOMAIN})
        store.dispatch('logout').then(() => {
          resolve()
        })
      })
      .catch(e => {
        console.log(e)
        reject()
      })
  })
}

export const checkHeimdallToken = _checkHeimdallToken
export const login = _login
export const logout = _logout



// WEBPACK FOOTER //
// ./src/app/services/authService.js